import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  ref: "dialog",
  class: "portal-password-notice",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "portal-password-notice-title",
  "aria-describedby": "portal-password-notice-description"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_createElementVNode("div", {
    class: "portal-password-notice-overlay",
    onKeydown: _cache[3] || (_cache[3] = (...args) => $options.onKeydown && $options.onKeydown(...args))
  }, [_createElementVNode("section", _hoisted_1, [_createElementVNode("button", {
    ref: "closeButton",
    class: "portal-password-notice-close",
    type: "button",
    "aria-label": "A tájékoztató bezárása",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
  }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true"
  }, [_createElementVNode("path", {
    d: "M5 5 19 19M19 5 5 19"
  })], -1)]))], 512), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "portal-password-notice-icon",
    "aria-hidden": "true"
  }, [_createElementVNode("svg", {
    viewBox: "0 0 52 52",
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M26 4c6.3 5.1 12.5 7.7 18 9.2v12.3c0 11.1-6.9 18.8-18 23.3C14.9 44.3 8 36.6 8 25.5V13.2C13.5 11.7 19.7 9.1 26 4Z"
  }), _createElementVNode("path", {
    d: "m17.5 26 5.6 5.7L35 19.5"
  })])], -1)), _cache[6] || (_cache[6] = _createElementVNode("h2", {
    id: "portal-password-notice-title"
  }, "Korábban már regisztrált?", -1)), _cache[7] || (_cache[7] = _createElementVNode("div", {
    id: "portal-password-notice-description",
    class: "portal-password-notice-copy"
  }, [_createElementVNode("h3", null, "Megújult a Virtuális Klinika páciensportálja!"), _createElementVNode("p", null, "Adatai biztonsága érdekében a korábban regisztrált pácienseinknek új jelszót kell beállítaniuk."), _createElementVNode("p", null, [_createTextVNode("Ha nem tud belépni, kérjen új jelszót a "), _createElementVNode("strong", null, "korábbi regisztráció során használt e-mail-címére.")]), _createElementVNode("div", {
    class: "portal-password-notice-highlight"
  }, "Új regisztrációra nincs szükség.")], -1)), _createElementVNode("button", {
    class: "portal-password-notice-action",
    type: "button",
    onClick: _cache[1] || (_cache[1] = $event => $options.navigate('Forgot password'))
  }, "Elfelejtett jelszó?"), _createElementVNode("button", {
    class: "portal-password-notice-back",
    type: "button",
    onClick: _cache[2] || (_cache[2] = $event => $options.navigate('login'))
  }, "Vissza a belépéshez")], 512)], 32)]);
}